'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _extends = require('@babel/runtime/helpers/extends');
var React = require('react');
var bumbag = require('bumbag');
var faSlidersH = require('@fortawesome/pro-regular-svg-icons/faSlidersH');
var faChevronLeft = require('@fortawesome/pro-solid-svg-icons/faChevronLeft');
var useMedia = require('use-media');
var router = require('../router.js');
var Layout_components_Content = require('./components/Content.js');
var Layout_components_Header = require('./components/Header.js');
var Layout_components_SubHeader = require('./components/SubHeader.js');
var WithTitle = require('../WithTitle.js');
var reactFontawesome = require('@fortawesome/react-fontawesome');
var reactRouterDom = require('react-router-dom');
require('@babel/runtime/helpers/defineProperty');
require('query-string');
require('@babel/runtime/helpers/objectWithoutPropertiesLoose');
require('@babel/runtime/helpers/taggedTemplateLiteralLoose');
require('./components/LoadingPage.js');
require('@fortawesome/pro-regular-svg-icons/faSpinnerThird');
require('./components/UserMenu.js');
require('@fortawesome/pro-solid-svg-icons/faComments');
require('@fortawesome/pro-solid-svg-icons/faBook');
require('@fortawesome/pro-solid-svg-icons/faSignOutAlt');
require('@fortawesome/pro-solid-svg-icons/faUser');
require('@fortawesome/pro-solid-svg-icons/faCaretDown');
require('@fortawesome/pro-solid-svg-icons/faQuestionCircle');
require('@medipass/utils/intercom');
require('@medipass/web-sdk');
require('../state.js');
require('constate');
require('../contexts/DataTableContext.js');
require('@fortawesome/pro-solid-svg-icons/faBars');
require('../hooks/useMediaQuery.js');
require('@babel/runtime/helpers/assertThisInitialized');
require('@babel/runtime/helpers/inheritsLoose');
require('react-document-title');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var useMedia__default = /*#__PURE__*/_interopDefaultLegacy(useMedia);

function MainPageWrapper(props) {
  var actionButtonsComponent = props.actionButtonsComponent,
      backButtonLink = props.backButtonLink,
      backButtonText = props.backButtonText,
      children = props.children,
      contentProps = props.contentProps,
      _props$sidebar = props.sidebar,
      sidebar = _props$sidebar === void 0 ? undefined : _props$sidebar,
      _props$shouldHideMobi = props.shouldHideMobileMenu,
      shouldHideMobileMenu = _props$shouldHideMobi === void 0 ? false : _props$shouldHideMobi,
      disablePadding = props.disablePadding,
      enableBackButton = props.enableBackButton,
      renderFilters = props.renderFilters,
      fromGetStarted = props.fromGetStarted,
      loadingTitle = props.loadingTitle,
      errorMessage = props.errorMessage,
      hasLegacySidebar = props.hasLegacySidebar,
      headerAddonComponent = props.headerAddonComponent,
      headerProps = props.headerProps,
      isLoading = props.isLoading,
      minWidthBreakpoint = props.minWidthBreakpoint,
      searchComponent = props.searchComponent,
      showHeader = props.showHeader,
      subHeaderComponent = props.subHeaderComponent,
      subHeaderProps = props.subHeaderProps,
      title = props.title,
      titleAddonComponent = props.titleAddonComponent,
      userMenuProps = props.userMenuProps;

  var _useRouter = router.useRouter(),
      query = _useRouter.location.query;

  var _useTheme = bumbag.useTheme(),
      theme = _useTheme.theme;

  var _useState = React.useState(false),
      showFilters = _useState[0],
      setShowFilters = _useState[1];

  var backLink = query.backLink || backButtonLink;
  var backText = backButtonText;

  if (fromGetStarted) {
    backLink = '/get-started';
    backText = 'Back to Get Started';
  }

  var isMobile = useMedia__default["default"]({
    maxWidth: theme.breakpoints.tablet
  });

  var showFiltersComponent = function showFiltersComponent() {
    if (renderFilters && isMobile && showFilters) {
      return true;
    }

    if (renderFilters && !isMobile) {
      return true;
    }

    return false;
  };

  return /*#__PURE__*/React__default["default"].createElement(WithTitle["default"], {
    title: title
  }, /*#__PURE__*/React__default["default"].createElement(bumbag.Flex, {
    flexDirection: "column",
    height: "100vh"
  }, showHeader && /*#__PURE__*/React__default["default"].createElement(Layout_components_Header["default"], _extends__default["default"]({
    hasLegacySidebar: hasLegacySidebar && !sidebar,
    sidebar: sidebar,
    shouldHideMobileMenu: shouldHideMobileMenu,
    headerAddonComponent: headerAddonComponent,
    minWidthBreakpoint: minWidthBreakpoint,
    title: title,
    titleAddonComponent: titleAddonComponent,
    userMenuProps: userMenuProps
  }, headerProps)), subHeaderComponent && /*#__PURE__*/React__default["default"].createElement(Layout_components_SubHeader["default"], _extends__default["default"]({
    minWidthBreakpoint: minWidthBreakpoint
  }, subHeaderProps), subHeaderComponent), /*#__PURE__*/React__default["default"].createElement(bumbag.Box, {
    id: "main-content",
    overflowY: "auto",
    height: "100vh"
  }, showFiltersComponent() && renderFilters && renderFilters({
    showFilters: showFilters,
    setShowFilters: setShowFilters,
    isMobile: isMobile
  }), /*#__PURE__*/React__default["default"].createElement(Layout_components_Content["default"], _extends__default["default"]({
    isMobile: isMobile // @ts-expect-error TS(2322): Type '{ children: (string | Element)[]; use: any; ... Remove this comment to see the full error message
    ,
    backLink: backLink,
    backText: backText,
    disablePadding: disablePadding // @ts-expect-error TS(2322): Type 'string | Record<string, any>' is not assigna... Remove this comment to see the full error message
    ,
    errorMessage: errorMessage,
    isLoading: isLoading,
    loadingTitle: loadingTitle,
    minWidthBreakpoint: minWidthBreakpoint,
    position: "relative"
  }, contentProps), backLink && enableBackButton && /*#__PURE__*/React__default["default"].createElement(bumbag.Button // @ts-expect-error TS(2322): Type '{ children: (string | Element)[]; use: any; ... Remove this comment to see the full error message
  , {
    use: reactRouterDom.Link,
    position: isMobile ? undefined : 'absolute',
    left: "1rem",
    top: "1rem",
    size: "small",
    palette: "secondary",
    variant: "ghost",
    to: backLink
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: "flex items-center justify-center whitespace-nowrap"
  }, /*#__PURE__*/React__default["default"].createElement(reactFontawesome.FontAwesomeIcon, {
    icon: faChevronLeft.faChevronLeft,
    className: "mr-1"
  }), /*#__PURE__*/React__default["default"].createElement("span", null, backText))), (searchComponent || actionButtonsComponent || renderFilters) && /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, isMobile ? /*#__PURE__*/React__default["default"].createElement(bumbag.Box, {
    width: "100%"
  }, actionButtonsComponent && /*#__PURE__*/React__default["default"].createElement(bumbag.Box, {
    marginBottom: "major-1"
  }, actionButtonsComponent), /*#__PURE__*/React__default["default"].createElement(bumbag.Columns, {
    minBreakpoint: "mobile",
    marginBottom: "0px"
  }, /*#__PURE__*/React__default["default"].createElement(bumbag.Columns.Column, {
    marginBottom: "0px"
  }, /*#__PURE__*/React__default["default"].createElement(bumbag.Box, {
    breakpoint: "tablet",
    width: "100%"
  }, searchComponent)), !showFilters && /*#__PURE__*/React__default["default"].createElement(bumbag.Columns.Column, {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end"
  }, /*#__PURE__*/React__default["default"].createElement(bumbag.Button, {
    variant: "ghost",
    palette: "secondary",
    size: "small",
    onClick: function onClick() {
      return setShowFilters(!showFilters);
    }
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: "flex items-center"
  }, /*#__PURE__*/React__default["default"].createElement(reactFontawesome.FontAwesomeIcon, {
    icon: faSlidersH.faSlidersH,
    className: "mr-2"
  }), /*#__PURE__*/React__default["default"].createElement("span", null, "Filters")))))) : /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, (searchComponent || actionButtonsComponent) && /*#__PURE__*/React__default["default"].createElement(bumbag.Columns, null, searchComponent && /*#__PURE__*/React__default["default"].createElement(bumbag.Columns.Column, null, /*#__PURE__*/React__default["default"].createElement(bumbag.Box, {
    breakpoint: "tablet",
    width: "100%"
  }, searchComponent)), /*#__PURE__*/React__default["default"].createElement(bumbag.Columns.Column, {
    display: "flex",
    justifyContent: "flex-end"
  }, actionButtonsComponent)))), children))));
}

MainPageWrapper.defaultProps = {
  actionButtonsComponent: undefined,
  backButtonLink: undefined,
  backButtonText: 'Back',
  contentProps: {},
  disablePadding: false,
  enableBackButton: true,
  errorMessage: undefined,
  searchComponent: undefined,
  fromGetStarted: false,
  headerAddonComponent: undefined,
  headerProps: {},
  isLoading: false,
  loadingTitle: undefined,
  minWidthBreakpoint: undefined,
  renderFilters: undefined,
  showHeader: true,
  subHeaderComponent: undefined,
  subHeaderProps: {},
  titleAddonComponent: undefined,
  children: /*#__PURE__*/React__default["default"].createElement(bumbag.Box, null),
  userMenuProps: {},
  hasLegacySidebar: true
};

exports["default"] = MainPageWrapper;
